import { MarkdownWrapper } from '@/components/MarkdownWrapper'
import { useTrace } from '@/hooks'
import { Traceable } from '@repo/shared/dtos/assistant'
import { cn } from '@repo/ui/utils'
import { ReactNode } from 'react'

export function AssistantMessage({
  className,
  children,
  traceUrl,
}: {
  children: ReactNode | string
  className?: string
} & Traceable) {
  const { Trace } = useTrace({ traceUrl })
  const isString = typeof children === 'string'
  const hasHtmlOrMarkdown =
    isString &&
    (/<\/?[a-z][\s\S]*>/i.test(children) || /[#_*~`]/.test(children))
  return (
    <div
      className={cn(
        'text-primary-200 bg-primary-900 shadow-primary/80 overflow-visible rounded-lg bg-opacity-90 p-4 shadow-md',
        !hasHtmlOrMarkdown && 'whitespace-pre-wrap text-pretty',
        className,
      )}
    >
      {hasHtmlOrMarkdown ? (
        <MarkdownWrapper theme="dark" content={children} />
      ) : (
        children
      )}
      <Trace />
    </div>
  )
}

export function AssistantUserMessage({ children }: { children: ReactNode }) {
  return (
    <div className="flex justify-end">
      <div className="text-primary-200 shadow-primary/80 bg-primary-950 ml-24 flex items-start gap-2 whitespace-pre-wrap rounded-lg bg-opacity-90 p-4 text-base shadow-md">
        {children}
      </div>
    </div>
  )
}
